import { PaginatedResponse } from "./paginated-response";

export class TaskStatusHistory extends PaginatedResponse {
    records: TaskStatusReport[] = [];
}

export class TaskStatusReport{
    worksheetId: string;
    worksheetName: string;
    projectId: string;
    projectName: string;
    marketName: string;
    initiatorId: string;
    initiatorName: string;
    oracleProjectNumber: string;
    oracleProjectName: string;
    oracleSiteNumber: string;
    status: string;
    orderNumber: string;
    purchaseOrderNumber: string;
    creationDate: string;
    closureDate: string;
    closedBy: string;
    daysToClosure: string;
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/task-report.ts